<!--
 * @Author: daidongyu daidongyu@cnuri.cn
 * @Date: 2021-08-30 13:47:46
 * @LastEditors: daidongyu daidongyu@cnuri.cn
 * @LastEditTime: 2022-08-09 11:16:01
 * @FilePath: /my-activation/src/CodeDetails/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="app" style="background:white">
    <div class="add">
      <longcode :onecode="2"></longcode>
    </div>
    <div class="tishibor" v-if="botn"></div>
    <div class="zhidao" v-if="botn">
      <div class="top">
        <i class="iconfont iconanquan"></i>
      </div>
      <div class="cen">
        付款码数字仅用于支付时向收银员展示,<br />请勿发送给他人,以防诈骗
      </div>
      <div class="bot" @click="clickBot">知道了</div>
    </div>
    <div :class="[botn == true ? 'op' : '']">
      <Return></Return>
    </div>
  </div>
</template>
<script>
export default {
  name: "CodeDetails",
  data() {
    return {
      botn: true,
      Barcode: ""
    };
  },
  mounted() {},
  methods: {
    clickBot() {
      this.botn = false;
    }
  }
};
</script>
<style scoped>
.app {
  width: 100%;
  height: 100%;
}
.add {
  width: 100%;
  height: 200px;
  z-index: 9;
}
.tishibor {
  position: fixed;
  top: 50%;
  margin-top: -100px;
  transform: rotate(90deg);
  width: 100%;
  height: 200px;
  background: #fff;
  opacity: 0.95;
  z-index: 99;
}
.zhidao {
  position: fixed;
  top: 48%;
  margin-top: -100px;
  transform: rotate(90deg);
  width: 100%;
  height: 200px;
  z-index: 9999;
  text-align: center;
}
.top {
  width: 100%;
  margin-top: 40px;
}
.iconanquan {
  font-size: 34px;
  color: #46a1ff;
}
.cen {
  margin-top: 7px;
  font-size: 10px;
  color: #000;
  margin-bottom: 12px;
}
.bot {
  width: 90px;
  height: 28px;
  line-height: 28px;
  margin: 0 auto;
  border: 0.5px solid #46a1ff;
  border-radius: 3px;
  color: #46a1ff;
  font-size: 10px;
}
.op {
  opacity: 0.4;
}
</style>



// WEBPACK FOOTER //
// src/CodeDetails/index.vue